module.exports = __webpack_public_path__ + "img/xp-tb-gamification-hero.876a520.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gamification/xp-tb-gamification-hero.png
// module id = Oh3o
// module chunks = 39 44